export enum SnackbarEnum {
  Feedback = 'feedback',
  Deleting = 'deleting',
}

export type SnackbarType = SnackbarEnum.Feedback | SnackbarEnum.Deleting;
